import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_TAG_TITLE':
    case 'UPDATE_TAG_SLUG':
    case 'UPDATE_TAG_DESCRIPTION':
    case 'UPDATE_TAG_SEO':
    case 'UPDATE_TAG_CATEGORIES':
    case 'UPDATE_TAG_STEP': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
